import { Button, notification } from 'antd'

const KEY = 'notification-permission'
let shown = false

// Browsers (Firefox and Safari strictly, Chrome increasingly) only allow
// Notification.requestPermission() inside a user gesture, so rather than asking
// at boot we show a prompt and request permission from its button.
export const showNotificationPermissionPrompt = (onEnable: () => void) => {
  // once per page load, so a dismissal isn't undone by the next auth change
  if (shown) {
    return
  }
  shown = true
  notification.info({
    key: KEY,
    message: 'Enable notifications',
    description:
      'Allow browser notifications to receive live updates, such as parking photos and permission changes.',
    duration: 0,
    placement: 'topLeft',
    btn: (
      <Button
        type="primary"
        size="small"
        onClick={() => {
          notification.close(KEY)
          onEnable()
        }}
      >
        Enable
      </Button>
    ),
  })
}
